export function textWithFilterCount(text: string, filterCount: number): string {
  return filterCount > 0 ? `${text} (${filterCount})` : text
}

export function getMobileDropdownColumnItemCount(number: number = 8) {
  return number >= 8 ? Math.ceil(number / 2) : number
}
